import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { URI } from '../../../services/service';

// import Frontend_UI from ;

const MediaContentView = ({ cmsUrl }) => {

  const [htmlContent, setHtmlContent] = useState(null);
  useEffect(() => {

    axios.get(cmsUrl)
      .then(response => {
        setHtmlContent(response.data);
        //console.log(response);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [cmsUrl]);

  return (
    // <iframe
    // 	title="Embedded HTML Page for Video Streaming"
    // 	srcDoc={`<base href=${Frontend_UI} /><div>${
    // 		htmlContent === undefined || htmlContent ===null ? 
    // 		<div style={{}}>Loading...</div> 
    // 		: htmlContent
    // 	}</div>`}
    // 	width="100%"
    // 	height="800"
    // />
    <iframe
      title="Embedded HTML Page for Video Streaming"
      srcDoc={`
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <base href="${URI.SERVER?._FRONTEND_UI}" />
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <style>
                *, *::before, *::after {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                }
                html, body {
                    width: 100%;
                    height: 100%;
                    background: transparent;
                }
                .content-wrapper {
                    position: relative;
                    width: 100%;
                    height: 100%;
                }
                .loader {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    gap: 12px;
                    color: #666;
                    font-size: 14px;
                }
                .loader-spinner {
                    width: 36px;
                    height: 36px;
                    border: 3px solid #e0e0e0;
                    border-top-color: #3b82f6;
                    border-radius: 50%;
                    animation: spin 0.8s linear infinite;
                }
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            </style>
        </head>
        <body>
            <div class="content-wrapper">
                ${htmlContent ?? `
                    <div class="loader">
                        <div class="loader-spinner"></div>
                        <span>Loading...</span>
                    </div>
                `}
            </div>
        </body>
        </html>
    `}
      width="100%"
      height="700"
      style={{
        border: "none",
        display: "block",
      }}
    />
    // <iframe
    //   title="Embedded HTML Page for Video Streaming"
    //   srcDoc={`<base href=${Frontend_UI} /><div style="position: relative; height: 800px;">${htmlContent === undefined || htmlContent === null ?
    //       '<div class="loader" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100px; height: 100px; border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; animation: spin 2s linear infinite;"></div>'
    //       : htmlContent
    //     }</div>`}
    //   width="100%"
    //   height="800"
    //   style={{ position: "relative" }}
    // />


  )
}

export default MediaContentView;

